import { IReportedImage } from "../redux/types";

export const ReportedImageSequence: IReportedImage["classification"][] = [
  "BEFORE",
  "AFTER",
  "ALERT"
];
